

<template>
  <div>
    <div class="scrollingTipWarp" @click="next">
      <div class="scrollingTipWarpText fOR">Scrolling</div>
      <div class="scrollingTipWarpImgWarp">
        <img class="scrollingTipWarpImg" src="../../assets/image/xiala.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";

export default {
  name:"scrollingView",
  computed:{
    currenIndex(){
      return this.$store.getters.pageCurrentIndex;
    }
  },
  methods:{
    next(){
      if(this.currenIndex>=5){
        return false
      }
      // this.$store.dispatch('setPageCurrentIndex',this.currenIndex + 1)
      this.$emit('next')
    }
  }
}
</script>
<style scoped lang="scss">
  .scrollingTipWarp{
    position: fixed;
    bottom: 2rem;
    left: 5rem;
    cursor: pointer;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .scrollingTipWarpText{
      font-size: .85rem;
      transform: rotate(90deg);
      color: rgba(255,255,255,.8);
    }
    .scrollingTipWarpImgWarp{
      padding-top: 1.7rem;
      padding-right: .2rem;
      .scrollingTipWarpImg{
        width: 1.2rem;
        display: block;
      }
    }
  }
</style>
